/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Line_Meta_No_CodeInputs */

const vi_kiotviet_line_meta_no_code = /** @type {(inputs: Kiotviet_Line_Meta_No_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có mã KiotViet`)
};

/**

* @param {Kiotviet_Line_Meta_No_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_line_meta_no_code = /** @type {((inputs?: Kiotviet_Line_Meta_No_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Line_Meta_No_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_line_meta_no_code(inputs)
});